<template>
  <button @click="list" type="button" class="btn btn-sm btn-secondary mr-1">
    <font-awesome-icon icon="info"/>&nbsp;{{$t('info')}}
    <b-modal size="xl" :content-class="tabIndex === 3 ? 'modal-content-2' : ''" header-class="pb-0" min header-bg-variant="white" v-model="showList" hide-footer ok-only no-close-on-backdrop no-enforce-focus>
      <template #modal-title>
        <b-tabs nav-class="nav-item-2" v-model="tabIndex">
          <b-tab>
            <template #title>
              <font-awesome-icon icon="info"/>&nbsp;{{$t('campaignInfo')}}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="book"/>&nbsp;{{$t('contactInfo')}}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="file"/>&nbsp;{{$t('content')}}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              <font-awesome-icon icon="list"/>&nbsp;{{ $t('contactList') }}
            </template>
          </b-tab>
        </b-tabs>
      </template>
      <template v-if="tabIndex === 0">
        <info :campaign="campaign"></info>
      </template>
      <template v-if="tabIndex === 1">
        <contact-fields :campaign="campaign"></contact-fields>
      </template>
      <template v-if="tabIndex === 2">
        <campaign-content :campaign="campaign"></campaign-content>
      </template>
      <template v-if="tabIndex === 3">
        <contact-list :campaign="campaign"></contact-list>
      </template>
    </b-modal>
  </button>
</template>
<script>
import Info from './info/Info';
import ContactList from './info/ContactList';
import ContactFields from './info/ContactFields'
import Content from './info/Content'

export default {
  props: {
    client: Object,
    campaign: Object
  },
  components: {ContactList, Info, ContactFields, "campaign-content": Content},
  data() {
    return {
      showList: false,
      tabIndex: 0
    }
  },
  methods:{
    list() {
      this.showList = true;
    }
  },
  i18n: {
    messages: {
      en: {
        contactList: "Contact list",
        campaignInfo: "Campaign info",
        contactInfo: "Contact info",
        content: "Content"
      },
      vi: {
        contactList: "Danh sách liên hệ",
        campaignInfo: "Thông tin chiến dịch",
        contactInfo: "Thông tin liên hệ",
        content: "Nội dung"
      }
    }
  },
}
</script>
<style>
.modal-content-2 {
  background-color: #e5e5e5;
}
.nav-item-2 {
  font-weight: normal;
  font-size: medium;
}
</style>